import React from 'react';
import { EmployeeRole } from 'types';
import { RoleActions } from './roleActions';

export const messagingReview = (inviteRole?: EmployeeRole, messageEntity?: string, isMultiInvite?: boolean) => {
  if (isMultiInvite) return 'Review and accept your invitations.';
  if (inviteRole === EmployeeRole.EMPLOYEE) {
    return (
      <>
        {`Review and accept to ${RoleActions.EMPLOYEE} from `} <strong>{messageEntity}</strong>.
      </>
    );
  }
  if (inviteRole === EmployeeRole.MANAGER) {
    return (
      <>
        {`Review and accept to ${RoleActions.MANAGER} at `} <strong>{messageEntity}</strong>.
      </>
    );
  }
  if (inviteRole === EmployeeRole.SITE_ADMIN) {
    return (
      <>
        {`Review and accept to ${RoleActions.SITE_ADMIN} at `} <strong>{messageEntity}</strong>.
      </>
    );
  }
  if (inviteRole === EmployeeRole.ADMIN) {
    return (
      <>
        {`Review and accept to ${RoleActions.ADMIN} at `} <strong>{messageEntity}</strong>.
      </>
    );
  }
  return null;
};
